export let PATH_NEW_MANAGER = '/management/';
export let PATH_NEW_MANAGER_MANAGER_SETTINGS = '/#/settings/manager/';
export let PATH_OLD_MANAGER = '../../old-management/';
export let PATH_ADVANCED_REPORTING = '../../reporting/';
export let PATH_LSL_BACKOFFICE = '../../hospitality_l-series/';
export let PATH_INVOICES = '../../invoices';
export let ANGULAR_WRAPPER_ID = 'angularWrapper';
export let ENDPOINTS: {
  report: string;
} = {
  report: 'reportingUrl'
};
